{
  "VALIDATION_FAILED": "يرجى التحقق من البيانات المدخلة",
  "USERNAME_TAKEN": "اسم المستخدم هذا مستخدم بالفعل",
  "NO_PLATFORM_ACCESS": "ليس لديك صلاحية الوصول إلى هذا النظام",
  "UA_UNAVAILABLE": "تعذر الوصول إلى الدخول الموحد. أعد المحاولة بعد قليل.",
  "UNAUTHENTICATED": "يجب تسجيل الدخول",
  "INVALID_CREDENTIALS": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
  "TOKEN_EXPIRED": "انتهت صلاحية الجلسة",
  "TOKEN_REVOKED": "تم إلغاء الجلسة",
  "FORBIDDEN": "ليس لديك صلاحية لتنفيذ هذا الإجراء",
  "NOT_FOUND": "العنصر المطلوب غير موجود",
  "routeNotFound": "هذه الصفحة غير موجودة.",
  "CONFLICT": "تعارض في البيانات. أعد تحميل البيانات الحالية.",
  "UNIQUE_VIOLATION": "هذه القيمة مستخدمة بالفعل",
  "FOREIGN_KEY_VIOLATION": "هذا العنصر مرتبط بعناصر أخرى ولا يمكن حذفه",
  "RATE_LIMITED": "عدد كبير جدا من المحاولات. أعد المحاولة بعد قليل.",
  "IDEMPOTENCY_KEY_REUSED": "تم استخدام رقم هذا الطلب لعملية أخرى مسبقا",
  "REQUEST_IN_PROGRESS": "لا يزال هذا الطلب قيد المعالجة",
  "PAYLOAD_TOO_LARGE": "البيانات المرسلة تتجاوز الحجم المسموح به",
  "UNPROCESSABLE": "تعذرت معالجة الطلب. تحقق من البيانات المرسلة.",
  "INTERNAL_ERROR": "تعذر إكمال العملية. أعد المحاولة أو تواصل مع المسؤول.",
  "SERVICE_UNAVAILABLE": "الخدمة غير متاحة حاليا. أعد المحاولة بعد قليل.",
  "NO_TIER_FOR_AMOUNT": "لا توجد شريحة لهذا المبلغ",
  "COMMISSION_NOT_BELOW_AMOUNT": "يجب أن تكون العمولة أقل من مبلغ الحوالة",
  "INSUFFICIENT_BALANCE": "الرصيد غير كافٍ لإتمام العملية",
  "TIER_LIMIT_TAKEN": "توجد شريحة أخرى بنفس الحد الأعلى",
  "TIER_UNLIMITED_EXISTS": "توجد شريحة أخرى بلا حد",
  "IN_USE": "لا يمكن الحذف لأنه مستخدم. يمكنك تعطيله بدلا من ذلك.",
  "HOLDER_INACTIVE": "الصندوق أو الحساب البنكي غير فعال",
  "BRANCH_NOT_ALLOWED": "غير متاح في هذا الفرع",
  "CODE_TAKEN": "هذا الرمز مستخدم بالفعل",
  "IBAN_TAKEN": "رقم IBAN مسجل لحساب آخر",
  "ACCOUNT_NUMBER_TAKEN": "رقم الحساب مسجل لحساب آخر",
  "INVALID_STATE": "لا يمكن تنفيذ هذا الإجراء في حالة الحوالة الحالية",
  "CAPTURE_INCOMPLETE": "بيانات المستلم أو التوقيع غير مكتملة",
  "NOTHING_TO_CHANGE": "لا توجد تغييرات للحفظ",
  "TABLET_NOT_CONFIGURED": "خدمة التابلت غير مربوطة بهذا النظام",
  "TABLET_UNAVAILABLE": "تعذر الوصول إلى خدمة التابلت، أعد المحاولة",
  "TABLET_NOT_AVAILABLE": "جهاز التابلت غير متاح في هذا الفرع",
  "TABLET_BUSY": "التابلت مشغول",
  "FILE_INVALID": "الملف غير صالح",
  "CUSTOMERS_UNAVAILABLE": "تعذر الربط بمنصة العملاء، أعد المحاولة",
  "CUSTOMER_NOT_PRESENT": "الحوالة محفوظة بخيار «العميل غير موجود»، ولا تقبل التابلت أو بيانات العميل",
  "network": "تعذر الاتصال بالخادم. تحقق من اتصالك وأعد المحاولة.",
  "timeout": "لم نتمكن من تأكيد اكتمال العملية. تحقق من الحالة الحالية قبل إعادة المحاولة.",
  "referenceId": "رقم المرجع: {{requestId}}",
  "PHONE_REQUIRED": "رقم الهاتف مطلوب",
  "PHONE_INVALID": "رقم الهاتف غير صالح",
  "PHONE_NOT_MOBILE": "رقم أرضي غير مسموح، أدخل رقم خلوي",
  "PHONE_COUNTRY_NOT_ALLOWED": "أرقام هذه الدولة غير مقبولة",
  "PHONE_VERIFICATION_REQUIRED": "يجب تأكيد رقم الهاتف قبل الحفظ",
  "PHONE_VERIFICATION_INVALID": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_INVALID": "الرمز غير صحيح",
  "OTP_EXPIRED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_ATTEMPTS_EXCEEDED": "تم تجاوز عدد المحاولات، اطلب رمزا جديدا",
  "OTP_RESEND_TOO_SOON": "إعادة إرسال الرمز غير متاحة الآن",
  "OTP_SEND_LIMIT": "تم إرسال عدد كبير من الرموز لهذا الرقم",
  "OTP_SEND_FAILED": "تعذر إرسال رمز التحقق عبر واتساب ولم يتم الحفظ. حاول مجددا، أو يمكن للمسؤول إيقاف تأكيد الرقم من الإعدادات",
  "OTP_ALREADY_VERIFIED": "تم تأكيد رقم الهاتف",
  "OTP_ALREADY_CONSUMED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_BINDING_MISMATCH": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_NOT_VERIFIED": "يجب تأكيد رقم الهاتف قبل الحفظ",
  "OTP_CONSUME_WINDOW_PASSED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "IDEMPOTENCY_CONFLICT": "تم استخدام رقم هذا الطلب لعملية أخرى مسبقا",
  "PHONE_VERIFICATION_RECEIPT_EXPIRED": "انتهت صلاحية تأكيد الرقم، أعد التحقق",
  "CUSTOMERS_CALL_IN_FLIGHT": "جاري إرسال بيانات العميل إلى نظام العملاء، أعد المحاولة بعد لحظات"
}
